import { render, staticRenderFns } from "./ReceivableCard.vue?vue&type=template&id=d4490358&scoped=true"
import script from "./ReceivableCard.vue?vue&type=script&lang=js"
export * from "./ReceivableCard.vue?vue&type=script&lang=js"
import style0 from "./ReceivableCard.vue?vue&type=style&index=0&id=d4490358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4490358",
  null
  
)

export default component.exports